<div class="row match-height justify-content-center">
    <div class="col-md-7">
        <div class="content-wrapper container-xxl p-0">
            <div class="content-body">
                <app-content-header [contentHeader]="contentHeader"></app-content-header>
            
                <section id="basic-vertical-layouts">
                    <div class="row match-height justify-content-center">
                      <div class="col-md-12 col-12">

                          <div class="card-body">
                            <div class="alert alert-primary p-1">If you are changing your pin for the first time, your default pin is <b>(0000)</b></div>
                            <form class="form form-vertical">
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="first-name-vertical"><h6>Old Wallet PIN</h6></label>
                                    <input
                                      type="text"
                                      [(ngModel)]="old_pin"
                                      id="first-name-vertical"
                                      class="form-control"
                                      name="password"
                                      placeholder="Old Wallet PIN"
                                    />
                                  </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                      <label for="first-name-vertical"><h6>New Wallet PIN</h6></label>
                                      <input
                                        type="password"
                                        id="first-name-vertical"
                                        class="form-control"
                                        [(ngModel)]="new_pin"
                                        name="password"
                                        placeholder="New Wallet PIN"
                                      />
                                    </div>
                                </div>
                                <div class="col-12">
                                  <button (click)="submitPin()" *ngIf="disable === false" type="submit" rippleEffect class="btn btn-primary mr-1">Submit</button>
                                  <button *ngIf="disable === true" type="submit" rippleEffect class="btn btn-outline-secondary mr-1">Updating...</button>
                                </div>
                              </div>
                            </form>
                          </div>
                      </div>
                    </div>
                  </section>
    
            </div>
        </div>
    </div>

</div>
    